<template>
  <h5>
    <!--
    <span :class="'badge bg-' + extra.positive_bg" v-if="Boolean(parseInt($store.getters.device(extra.serial)[extra.name]))">{{ extra.positive_title }}</span>
    <span :class="'badge bg-' + extra.negative_bg" v-if="!Boolean(parseInt($store.getters.device(extra.serial)[extra.name]))">{{ extra.negative_title }}</span>
    -->
    <span :class="'badge bg-' + extra.positive_bg" v-if="getBoolean($store.getters.device(extra.serial)[extra.name])">{{ extra.positive_title }}</span>
    <span :class="'badge bg-' + extra.negative_bg" v-if="!getBoolean($store.getters.device(extra.serial)[extra.name])">{{ extra.negative_title }}</span>
  </h5>
</template>

<script>
export default {
  props: ['title', 'extra'],
  methods: {
    getBoolean (value) {
      if (value || !value) {
        return value
      } else {
        return Boolean(parseInt(value))
      }
    }
  }
}
</script>
